import { featureType as FeatureType } from "../../types/Feature";
import useFeatures from "../../api/hooks/useFeatures";
import NavigationCard from "./NavigationCard";
import { isMobile } from "src/utils/isMobile";
import { Modal } from "../Modal";
import useMyUser from "src/api/hooks/useMyUser";
import { routes } from "src/routes";

const inspectionFeature = {
  id: 0,
  name: "Inspection",
  description: "",
  plugin: "",
  path: "",
  url: "",
  icon: "",
} as FeatureType;

const deviationFeature = {
  id: 0,
  name: "deviation",
  description: "",
  plugin: "",
  path: "",
  url: "",
  icon: "",
} as featureType;

const plannerFeature = {
  id: 0,
  name: "Planner",
  description: "",
  plugin: "",
  path: routes.Planner.path,
  url: routes.Planner.path,
  icon: "",
} as featureType;

const signingSessionFeature = {
  id: 0,
  name: "SigningSession",
  description: "",
  plugin: "",
  path: routes.SigningSession.Documents.path,
  url: routes.SigningSession.Documents.path,
  icon: "",
} as featureType;

const vehicleInspectionFeature = {
  id: 0,
  name: "VehicleInspection",
  description: "",
  plugin: "",
  path: routes.VehicleInspection.ActiveSchemas.path,
  url: routes.VehicleInspection.ActiveSchemas.path,
  icon: "fa-solid fa-car-side",
} as featureType;

const StartPageFeature = {
  id: 0,
  name: "StartPage",
  description: "",
  plugin: "",
  path: routes.Start.path,
  url: routes.Start.path,
  icon: " fa-solid fa-home",
} as featureType;

const ReportPageFeature = {
  id: 0,
  name: "ReportPage",
  description: "",
  plugin: "",
  path: routes.Report.path,
  url: routes.Report.path,
  icon: " fa-solid fa-file-pen-nib",
} as featureType;

export type featureType = typeof inspectionFeature;

export default function NavigationMenu({
  isMenuOpen,
  setIsMenuOpen,
}: {
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
}) {
  const features = useFeatures();
  const { data: myUser } = useMyUser();

  if (!isMenuOpen) return null;

  return (
    <Modal
      onOutsideClick={() => setIsMenuOpen(false)}
      className="w-full h-full p-0"
    >
      <NavigationCard
        key="StartPageFeature"
        feature={StartPageFeature}
        setIsMenuOpen={setIsMenuOpen}
      />
      <NavigationCard
        key="inspectionFeature"
        feature={inspectionFeature}
        setIsMenuOpen={setIsMenuOpen}
      />
      {/* <NavigationCard
        key="deviationFeature"
        feature={deviationFeature}
        setIsMenuOpen={setIsMenuOpen}
      /> */}
      {myUser?.username === "andreas.lofkvist@GLNET.SE" && (<NavigationCard
        key="ReportPageFeature"
        feature={ReportPageFeature}
        setIsMenuOpen={setIsMenuOpen}
      />)
}
      {myUser?.username === "andreas.lofkvist@GLNET.SE" && (
        <NavigationCard
          key="PlannerFeature"
          feature={plannerFeature}
          setIsMenuOpen={setIsMenuOpen}
        />
      )}
      {(myUser?.username === "andreas.lofkvist@GLNET.SE" ||
        myUser?.companyId === 1 ||
        features.data?.find((item) => item.name === "SigningSession")) && (
        <NavigationCard
          key="SigningSessionFeature"
          feature={signingSessionFeature}
          setIsMenuOpen={setIsMenuOpen}
        />
      )}
      {myUser?.id === 5 && (
        <NavigationCard
          key="VehicleInspectionFeature"
          feature={vehicleInspectionFeature}
          setIsMenuOpen={setIsMenuOpen}
        />
      )}
    </Modal>
  );
}
